import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueMaterial from 'vue-material'
import axios from 'axios'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import './css/material.css'
import './css/index.css'
//import https from 'https'

import store from './store/index'

import router from './routes/index'

import DisableAutocomplete from '@aacassandra/vue-disable-autocomplete';

process.env["NODE_TLS_REJECT_UNAUTHORIZED"] = 0;
/*
const instance = axios.create({
  httpsAgent: new https.Agent({  
    rejectUnauthorized: false
  })
});
instance.get('https://45.79.100.64/');
*/

Vue.use(DisableAutocomplete);
Vue.prototype.$axios = axios

Vue.use(VueMaterial)
Vue.use(VueRouter)

import { NumericTextBoxComponent, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DatePickerComponent, DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";

Vue.use(DropDownListPlugin);
Vue.component(NumericTextBoxPlugin.name, NumericTextBoxComponent);
Vue.component(DatePickerPlugin.name, DatePickerComponent);

import {setCulture} from '@syncfusion/ej2-base';

setCulture('ar');

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')

